import { selectIsLoggedIn } from '../api-integration/common.slice';
import { useAppSelector } from '../hooks/redux';
import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

interface GuestGuardProps {
  children: ReactNode;
}

const NonAuthGuard: FC<GuestGuardProps> = ({ children }) => {
  const location = useLocation();
  const redirectURL = sessionStorage.getItem("redirectURL");
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  // removed local storage initialization

  const isSocialNetworkConnection = location.pathname.includes('/external');

  // If NOT logged in or social network connection, allow access
  if (!isLoggedIn || isSocialNetworkConnection) {
    return <>{children}</>;
  }

  // Logged in & has redirect URL → redirect to it
  if (redirectURL) {
    return <Navigate to={redirectURL} replace />;
  }

  // Logged in & NO redirect → block access to non-auth pages
  return <Navigate to="/home" replace />;
};

NonAuthGuard.propTypes = {
  children: PropTypes.node,
};

export default NonAuthGuard;